exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select_panel_d91025b{display:flex}", ""]);

// exports
exports.locals = {
	"select_panel": "select_panel_d91025b"
};